import { gcApi } from 'config/axios';

const SetPrimaryTracker = {
    setPrimaryActivityTracker: function(deviceId, value, success, error) {
        gcApi
            .put(`/device-service/deviceservice/device-info/${deviceId}/primary-activity-tracker`, {
                data: value
            })
            .then(() => {
                if (typeof (success === 'function')) {
                    success();
                }
            })
            .catch(() => {
                if (typeof error === 'function') {
                    error();
                }
            });
    }
};

export default SetPrimaryTracker;
